import type {ActiveUserDto, MandatoryFlowUserDto} from "homey-housing-lottery-app-dto";

// Virtual statuses router.helper's guards match alongside the real ones. Kept free of Angular
// imports, and narrowed to the fields read, so backend/tests can check them against the backend
// domain.
export const completionStatuses = ['profile-complete', 'auto-applying', 'applying-manually'] as const;
export type CompletionStatus = typeof completionStatuses[number];

export const isCompletionStatus = (status: string): status is CompletionStatus =>
  completionStatuses.some(completionStatus => completionStatus === status);

type RoutedUser =
  | Pick<MandatoryFlowUserDto, 'status' | 'isProfileComplete'>
  | Pick<ActiveUserDto, 'status'> & { readonly autoApplySettings: Pick<ActiveUserDto['autoApplySettings'], 'enabled'> }
  | { readonly status: 'unauthorized' };

export const userMatchesCompletionStatus = (user: RoutedUser, status: CompletionStatus): boolean => {
  switch (status) {
    // The backend's MandatoryFlowUser.isProfileComplete(), which implies everything
    // completeMandatoryFlow() needs, so a user shown "Profile complete!" can activate after paying.
    case 'profile-complete':
      return user.status === 'mandatory-flow' && user.isProfileComplete;
    case 'auto-applying':
      return user.status === 'active' && user.autoApplySettings.enabled;
    case 'applying-manually':
      return user.status === 'active' && !user.autoApplySettings.enabled;
  }
};
